<template>
  <contact-search-provider
    ref="provider"
    :filters="filters"
    :items-per-page="itemsPerPage"
    :account-id="accountId"
    :disabled="disabled"
    silent>
    <template #default="{ hits, refine }">
      <coozzy-search-multiselect
        v-bind="$attrs"
        :value="value"
        :options="mappedOptions(hits)"
        :multiple="multiple"
        :taggable="taggable"
        :internal-search="internalSearch"
        :disabled="disabled"
        @search-change="onSearchChange(refine, $event)"
        @input="$emit('input', $event)"
        @select="$emit('select', $event)"
        @remove="$emit('remove', $event)" />
    </template>
  </contact-search-provider>
</template>

<script>
import ContactSearchProvider from './ContactSearchProvider'
import CoozzySearchMultiselect from '../multiselect/CoozzySearchMultiselect'

/**
 * Contact picker backed by the search read model. Drop-in replacement for the
 * `<ais-instant-search> + <ais-autocomplete> + <coozzy-search-multiselect>` blocks that
 * used to query the Algolia contact index. Extra multiselect props are forwarded via `$attrs`.
 */
export default {
  name: 'ContactSearchSelect',
  components: {
    ContactSearchProvider,
    CoozzySearchMultiselect
  },
  inheritAttrs: false,
  props: {
    value: {
      type: [Array, String, Object],
      default: () => []
    },
    /** Any subset of the ListContacts filter fields, e.g. `{ active: true, ownerIds: ['4'] }`. */
    filters: {
      type: Object,
      default: () => ({})
    },
    accountId: {
      type: [String, Number],
      default: null
    },
    itemsPerPage: {
      type: Number,
      default: 10
    },
    /** Defaults match CoozzySearchMultiselect, which the migrated call sites relied on. */
    multiple: {
      type: Boolean,
      default: true
    },
    taggable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    internalSearch: {
      type: Boolean,
      default: true
    },
    /** Per-call-site post-processing of the hits, replacing the old `editObject()` helpers. */
    transformHits: {
      type: Function,
      default: null
    }
  },
  methods: {
    mappedOptions(hits) {
      return this.transformHits ? this.transformHits(hits) : hits
    },
    onSearchChange(refine, value) {
      refine(value)
      this.$emit('search-change', value)
    },
    reload() {
      return this.$refs.provider?.reload()
    }
  }
}
</script>
